<div class="row mainClassTerm">
  <div class="col-md-12 ps-0">
    <h5 [class.arabic-style]="isArabicLanguage" class="chart-query-container-title">
      <b [class.arabic-style]="isArabicLanguage">{{ 'textAnalysisPage.TermGroups' | translate }} - </b>
      @if (!isLimiterChanged) {
        <span>
          <b [class.arabic-style]="isArabicLanguage">{{'textAnalysisPage.AllDocuments'|translate}}</b>
          <p class="relevenc-info"> Term Clusters analyze the Top 1000 results based on relevance  <i class="relevanceIcon" title="More information about Term Clusters" tabindex="0"
          (click)="openRelevanceHelp($event);" (keyup.enter)="openRelevanceHelp($event);"></i> </p>
          <p [class.arabic-style]="isArabicLanguage" class="small m-t-20" [innerHTML]="'textAnalysisPage.groupsWithinTheWDA' | translate"
            [ngClass]="{'fontResponsive': lang.value === 'ta'}">
          </p>
        </span>
      }
      @if (isLimiterChanged) {
        <span>
          <b [class.arabic-style]="isArabicLanguage">{{'textAnalysisPage.LimitedDocuments'|translate}}</b>
          <p class="relevenc-info"> Term Clusters analyze the Top 500 results based on relevance  <i class="relevanceIcon" title="{{ 'Sort.relevanceRanking' | translate }}" tabindex="0"
          (click)="openRelevanceHelp($event);" (keyup.enter)="openRelevanceHelp($event);"></i> Click here for more information about Term Clusters.</p>
          <p [class.arabic-style]="isArabicLanguage" class="small m-t-20"
            [ngClass]="{'fontResponsive': lang === 'ta'}" [innerHTML]="'textAnalysisPage.groupsDocumentsLimitedBy' | translate">
          </p>
        </span>
      }
    </h5>

    @if (showHelpContainer) {
      <div class="relevance-help-container" [class.show-showRelevanceHelp]="showRelevanceHelp"
        (click)="$event.stopPropagation();" >
        <div class='text'> <h4> How do Term Groups Work? </h4> <p>Term Groups are presented by analyzing full text and subject terms from a subset of your search results (the top 1,000 relevancy-ranked results) and by feeding them into a clustering algorithm. The Term Groups represented in either “Foam Tree” or ”Circles” visualizations are based on the most commonly occurring keywords in those first 1,000 documents. Because Wiley Digital Archives utilizes real-time in-memory clustering of the terms, the search results are restricted to the top 1,000 relevant results. A search term or phrase is weighted depending on where the term or phrase appears in the document and metadata, and the overall relevance of a search result is factored by the frequency with which the term or phrase appears in the full text of the document.</p><p>The clustering algorithm aims to produce term groups with concise, varied, relevant and human-readable labels. Clustering results are derived from the text of the articles and metadata and do not rely on any other external sources. Note that the clustering may not be complete as the results depend on the varying quality of the derived OCR (optical character recognition) or ATR (automated text recognition) text. The algorithm is capable of extracting clusters from English, German, French, Simplified Chinese, Thai, and Arabic languages.</p><p>After a first view in Term Groups is obtained following a search, the user may also apply various limiters to constrain that view further, or toggle between Foam Tree and Circles views. The visualization is coded so that larger tiles or circles with darker colors are suggested as more relevant to the initial search term of phrase, while smaller, lighter views indicate more tertiary relationships to the initial search term or phrase. Users can click within any tiles for more detailed views, and may similarly inspect the clustering results in more detail by clicking on the arrows within the Circles view. When a user clicks on one of the tiles or circles, the 20 most relevant results within that cluster are presented in an adjacent results view, and users may go directly to any document from those results. </p><h4> Why Use Term Groups?</h4><p>Term Groups is a tool that may be useful in making connections between subjects, people, places, and ideas that are not otherwise apparent in a standard search results list or through indexing. While the tool is imperfect, Term Groups aids in understanding direct and indirect relationships within the content of the Wiley Digital Archives collections, and may help students, researchers, and others to understand and contextualize the content in ways that go beyond the basic “search and retrieve” paradigm of many databases.</p></div>
      </div>
    }
  </div>
  <div class="col-md-12 col-lg-6 col-sm-12 col-xs-12 padding-0">
    <div class="groups_frame-loader" [ngStyle]="{display: dataLoader ? 'block':'none'}">
      <img alt="{{'Alt.loaderImage' | translate}}" src="assets/images/dot-loader-dark.gif">
    </div>
    <a [class.arabic-style]="isArabicLanguage" href="javascript:void(0)" class="pull-right resetLink"
    (click)="resetAll()">{{ 'textAnalysisPage.reset' | translate }}</a>
    <tabset #foamtreeTabs class="docviewer-tabs">
      <tab heading="" (selectTab)="foamTreeActivated()" [active]="!formTreeTabIndex? true : false">
        <ng-template tabHeading>
          <span [class.arabic-style]="isArabicLanguage"
          title="{{ 'textAnalysisPage.foamTree' | translate }}">{{ 'textAnalysisPage.foamTree' | translate }}</span>
        </ng-template>
        <div id="visualization" style="width: 100%;height: 600px;"></div>
      </tab>

      <tab heading="" (selectTab)="circleActivated()" [active]="formTreeTabIndex? true : false">
        <ng-template tabHeading>
          <span [class.arabic-style]="isArabicLanguage"
          title="{{ 'textAnalysisPage.circles' | translate }}">{{ 'textAnalysisPage.circles' | translate }}</span>
        </ng-template>
        <div id="carrot-circles" style="width: 100%;height: 600px;"></div>
      </tab>
    </tabset>
  </div>

  <div class="col-md-12 col-lg-6 col-sm-12 inline-block contentlist">
    <div class="groups_frame-loader" [ngStyle]="{display: detailsLoader ? 'block':'none'}">
      <img class="groups-loader" alt="{{'Alt.loaderImage' | translate}}" src="assets/images/dot-loader-dark.gif">
    </div>
    <div class="col-md-12 padding-0 result-container">
      <!-- <perfect-scrollbar class="col-md-12 padding-0 result-container"> -->
      @if (groups?.length <= 0 && !detailsLoader) {
        <div class="alert alert-info h4" role="alert">
          <span [class.arabic-style]="isArabicLanguage"
          class="termGroupText">{{ 'textAnalysisPage.foamTreeInfo1' | translate }}</span>
          <span [class.arabic-style]="isArabicLanguage" class="termGroupText">
            {{ 'textAnalysisPage.foamTreeInfo2' | translate }}
            <b>{{ 'textAnalysisPage.foamTreeInfo3' | translate }}</b>
          </span>
        </div>
      }
      @if (groups?.length > 0) {
        <accordion class="searchresult-accordion">
          @for (group of groups; track group; let i = $index) {
            @if (pageContentData?.groupsToBeDisplayed?.length == 0 ? true : pageContentData?.groupsToBeDisplayed?.indexOf(group?.group) > -1) {
              <accordion-group
                [isOpen]="true" (isOpenChange)="checkAccordionStatus(i)">
                <div class="heading" accordion-heading>
                  @if (group?.group == 'Monographs') {
                    <i class="acc_icon monographIcon" aria-hidden="true"></i>
                  }
                  @if (group?.group == 'Manuscripts') {
                    <i class="acc_icon manuscriptsIcon" aria-hidden="true"></i>
                  }
                  {{group?.group}}
                  <span class="doc-count"> {{' (' + group?.documents.length + ')'}} </span>
                  @if (group?.group == 'Photographs') {
                    <i class="acc_icon photographIcon" aria-hidden="true"></i>
                  }
                  @if (group?.group == 'Maps') {
                    <i class="acc_icon mapIcon" aria-hidden="true"></i>
                  }
                  <i class="fa fa-chevron-down pull-right accordion-upicn accordionDownIcon{{i}}"
                  [ngStyle]="{'display': !togglesearchicon[i] ? 'block': 'none'}"></i>
                  <i class="fa fa-chevron-up pull-right accordion-upicn  accordionDownIcon{{i}}"
                  [ngStyle]="{'display': togglesearchicon[i] ? 'block': 'none'}"></i>
                </div>
                <div #getScrollElement [attr.data-scrollgroup]="group?.group"
                  [attr.data-scrolldoclength]="group?.documents.length"
                  [attr.data-scrolltotalgroup]="group?.totalGroupElements" [attr.data-gridviewscroll]="false">
                  @for (document of group?.documents; track document) {
                    <div class="col-md-12 col-xs-12 inline-display accordian-inner listViewSwitch padding-left-0"
                      >
                      @if (group?.documents.length > 0) {
                        <div class=" sub-content inline-display padding-left-0 img_pad {{group?.group}}class col-sm-2"
                          >
                          <div class="searchresult-imgdiv temgroups-searchresult-imgdiv" [attr.title]="document.title" data-placement="right"
                            aria-hidden="true">
                            <ng-template #imageSliderPOpover>
                              <div class="swipesliderclass">
                                <app-image-swipe-slider [documentIndex]="j" [document]="document" [group]="group?.group" [thumbnailImages]="document.imageThumbnails"
                                  (callDocViewerOutput)="callDocViewerFromOutput($event)"
                                  [hasFolderImage]="pageContentData.hasFolderImage && showFolderImage?.locations[document.archive]?.showFolderImage == 'false' && (group?.group === 'Manuscripts' || group?.group === 'Photographs')">
                                </app-image-swipe-slider>
                              </div>
                            </ng-template>
                            <a (click)="termGroupService.goToDetailsPage(document.id)" style="height: 100%; width: 100%">
                              <img class="accordian-img center-block img-responsive"
                        [attr.src]="pageContentData.hasFolderImage && (group?.group === 'Manuscripts' || group?.group === 'Photographs')?
                                (document.imageThumbnails?.length > 1 ? document.imageThumbnails[1]  : document.imageThumbnails[0] ) : (document.imageThumbnails ? document.imageThumbnails[0] : '' )"
                        alt="{{'Alt.imageThumbnails' | translate}}" (error)="errorHandler($event)" />
                              </a>
                              <i class="view-icn termsgroups-icon {{group?.group}}-icon" title="{{ 'SearchResult.PeekAtTheImagesInDoc' | translate }}" (click)='imgsliderToggle($event)'
                                tabindex="0" (keyup.enter)='imgsliderToggle($event)' tooltipPlacement="bottom" aria-hidden="true"
                              [outsideClick]="true" [popover]="imageSliderPOpover" [placement]="'left'"></i>
                              @if (document?.processType === 'atr') {
                                <img tooltip="This handwritten document is searchable." placement="right" alt="ATR Icon" class="atr-list-img-icon" src="assets/images/icons/ATRN3.png">
                              }
                              @if (document?.processType === 'drone') {
                                <img tooltip="This large-format map was captured by a drone." placement="right" alt="Drone Icon" class="atr-list-img-icon" src="assets/images/icons/Drone1.png">
                              }
                              @if (document?.isGeoBoundaryExist) {
                                <i class="view-icn {{group?.group}}-icon geo-icon" title="{{ 'SearchResult.gotoMapsExplorer' | translate }}"
                                tabindex="0" tooltipPlacement="bottom" (click)='gotoMapsExplorer(document?.id)' aria-hidden="true"></i>
                              }
                            </div>
                            <ng-template #Image [class.arabic-style]="isArabicLanguage">
                              {{ 'SearchResult.PeekAtTheImagesInDoc' | translate }}
                            </ng-template>
                            <!-- <tooltip-content #Image [class.arabic-style]="isArabicLanguage">
                          {{ 'SearchResult.PeekAtTheImagesInDoc' | translate }}</tooltip-content> -->
                        </div>
                      }
                      <ng-template #pageTitle class="{{group?.group}}GridTooltip">
                        <div class="pagetitle-popoverdiv">
                          <a [class.arabic-style]="isArabicLanguage" title="{{'Detail.documentTitle' | translate}}"
                          class="search-result-header-title">{{document.title}} </a>
                          <div [innerHtml]="document.citation"></div>
                        </div>
                      </ng-template>
                      <!-- <tooltip-content class="{{group?.group}}GridTooltip" #pageTitle>
                      <div class="pagetitle-popoverdiv">
                        <a [class.arabic-style]="isArabicLanguage" title="{{'Detail.documentTitle' | translate}}"
                        class="search-result-header-title">{{document.title}} </a>
                        <div [innerHtml]="document.citation"></div>
                      </div>
                    </tooltip-content> -->
                    <div id="accodianPanel"
                      class="col-md-12 col-sm-12 accodion-panel inline-display {{group?.group}}show getClassShow(group?.group) padding-right-0">
                      <div class=" pull-right gridview-panel">
                        <div class="panel-heading">
                          <h3 data-toggle="tooltip1" data-placement="bottom" [class.arabic-style]="isArabicLanguage">
                            <label [class.arabic-style]="isArabicLanguage" title="{{'Detail.documentTitle' | translate}}"
                              class="search-result-header-title headerTitle" [attr.title]="document.title"
                              (click)="termGroupService.goToDetailsPage(document.id)"
                            [class.docVisited]="visitedDocList?.indexOf(document.id)> -1">{{document.title}} </label>
                          </h3>
                          <div class="col-md-12 col-sm-11">
                            <div [innerHtml]="document.citation" class="docCitation"></div>
                            @if (group?.group == 'Manuscripts') {
                              <div class="image_count">
                                <span [class.arabic-style]="isArabicLanguage" class="img_count"> {{document.pageCount}}
                                </span> {{'Common.imagesinthis' | translate}} {{(group?.group?.substr(-1)
                              === 's')?group?.group?.substring(0,(group?.group?.length - 1)) :group?.group }}</div>
                            }
                            @if (group?.group == 'Monographs') {
                              <div class="image_count">
                                <span [class.arabic-style]="isArabicLanguage" class="img_count"> {{document.pageCount}}
                                </span> {{'Common.imagesinthis' | translate}}{{(group?.group?.substr(-1)
                              === 's')?group?.group?.substring(0,(group?.group?.length - 1)) :group?.group }}</div>
                            }
                            @if (group?.group == 'Photographs') {
                              <div class="image_count">
                                <span [class.arabic-style]="isArabicLanguage" class="img_count"> {{document.pageCount}}
                                </span> {{'Common.imagesinthis' | translate}} Photographic Collection</div>
                              }
                              @if (group?.group == 'Maps') {
                                <div class="image_count">
                                  <span [class.arabic-style]="isArabicLanguage" class="img_count"> {{document.pageCount}}
                                  </span> {{'Common.imagesinthis' | translate}}{{(group?.group?.substr(-1)
                                === 's')?group?.group?.substring(0,(group?.group?.length - 1)) :group?.group }}</div>
                              }
                            </div>
                            @if (pageContentData.currentArchive === 'WILEY') {
                              <div [class.arabic-style]="isArabicLanguage" class="source-citation">
                                <label [class.arabic-style]="isArabicLanguage" class="left-source">{{'Common.Source' | translate}} &nbsp;</label>
                                @if (document.archive ==='BAAS') {
                                  <label class="right-source italic">{{document.archive
                                    ==='BAAS' ? archivefullName :
                                  document.sourceInstitution}}</label>
                                }
                                @if (document.archive ==='ENV') {
                                  <label class="right-source italic">{{document.archive
                                    ==='ENV' ? ENVArchiveFullName :
                                  document.sourceInstitution}}</label>
                                }
                                @if (document.archive !=='BAAS' && document.archive !=='ENV') {
                                  <label
                                    class="right-source italic">{{document.archive ==='BAAS' ? archivefullName :
                                  document.sourceInstitution}}</label>
                                }
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </accordion-group>
            }
          }
        </accordion>
      }
    <!-- </perfect-scrollbar> -->
  </div>
</div>
</div>
